export const FILE_EXTENSIONS_TO_VALIDATE = [
  'pdf',
  'png',
  'gif',
  'jpeg',
  'heic',
];
